module.exports = __webpack_public_path__ + "media/application/images/svgs/navigation-96d4ba3c8069af06b8fdedd52a3c7078.svg";